import { createContext } from 'react';

export interface RetentionSearchContextValue {
    query: string;
    submittedQuery: string;
    error: string;
    loading: boolean;
    setQuery: (value: string) => void;
    submit: () => void;
}

export const RetentionSearchContext = createContext<RetentionSearchContextValue>({
    query: '',
    submittedQuery: '',
    error: '',
    loading: false,
    setQuery: () => {},
    submit: () => {},
});
